import PropTypes from "prop-types"
import React, { useCallback, useEffect, useRef } from "react"

// //Import Scrollbar
import SimpleBar from "simplebar-react"

// MetisMenu
import MetisMenu from "metismenujs"
import withRouter from "components/Common/withRouter"
import { Link } from "react-router-dom"

//i18n
import { withTranslation } from "react-i18next"

const SidebarContent = props => {
  const ref = useRef();

  // ====== Role-based sidebar filtering ======
  const getUserRole = () => {
    try {
      const role = localStorage.getItem("role");
      if (role) return role.toLowerCase().trim();
      const userStr = localStorage.getItem("user");
      if (userStr) {
        const u = JSON.parse(userStr);
        return (u.role || u.user_role || "").toLowerCase().trim();
      }
      const authStr = localStorage.getItem("authUser");
      if (authStr) {
        const a = JSON.parse(authStr);
        const u = a.user || a;
        return (u.role || u.user_role || "").toLowerCase().trim();
      }
    } catch (e) { /* ignore */ }
    return "";
  };

  const userRole = getUserRole();
  const isAdmin = userRole === "admin";
  const isDataEntry = userRole === "data_entry";
  const isAdminOrDataEntry = isAdmin || isDataEntry;

  const activateParentDropdown = useCallback((item) => {
    item.classList.add("active");
    const parent = item.parentElement;
    const parent2El = parent.childNodes[1];

    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show");
    }

    if (parent) {
      parent.classList.add("mm-active");
      const parent2 = parent.parentElement;

      if (parent2) {
        parent2.classList.add("mm-show"); // ul tag

        const parent3 = parent2.parentElement; // li tag

        if (parent3) {
          parent3.classList.add("mm-active"); // li
          parent3.childNodes[0].classList.add("mm-active"); //a
          const parent4 = parent3.parentElement; // ul
          if (parent4) {
            parent4.classList.add("mm-show"); // ul
            const parent5 = parent4.parentElement;
            if (parent5) {
              parent5.classList.add("mm-show"); // li
              parent5.childNodes[0].classList.add("mm-active"); // a tag
            }
          }
        }
      }
      scrollElement(item);
      return false;
    }
    scrollElement(item);
    return false;
  }, []);

  const removeActivation = (items) => {
    for (var i = 0; i < items.length; ++i) {
      var item = items[i];
      const parent = items[i].parentElement;

      if (item && item.classList.contains("active")) {
        item.classList.remove("active");
      }
      if (parent) {
        const parent2El =
          parent.childNodes && parent.childNodes.lenght && parent.childNodes[1]
            ? parent.childNodes[1]
            : null;
        if (parent2El && parent2El.id !== "side-menu") {
          parent2El.classList.remove("mm-show");
        }

        parent.classList.remove("mm-active");
        const parent2 = parent.parentElement;

        if (parent2) {
          parent2.classList.remove("mm-show");

          const parent3 = parent2.parentElement;
          if (parent3) {
            parent3.classList.remove("mm-active"); // li
            parent3.childNodes[0].classList.remove("mm-active");

            const parent4 = parent3.parentElement; // ul
            if (parent4) {
              parent4.classList.remove("mm-show"); // ul
              const parent5 = parent4.parentElement;
              if (parent5) {
                parent5.classList.remove("mm-show"); // li
                parent5.childNodes[0].classList.remove("mm-active"); // a tag
              }
            }
          }
        }
      }
    }
  };

  const activeMenu = useCallback(() => {
    const pathName = process.env.PUBLIC_URL + props.router.location.pathname;
    let matchingMenuItem = null;
    const ul = document.getElementById("side-menu");
    const items = ul.getElementsByTagName("a");
    removeActivation(items);

    for (let i = 0; i < items.length; ++i) {
      if (pathName === items[i].pathname) {
        matchingMenuItem = items[i];
        break;
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem);
    }
  }, [props.router.location.pathname, activateParentDropdown]);

  useEffect(() => {
    ref.current.recalculate();
  }, []);

  useEffect(() => {
    new MetisMenu("#side-menu");
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    activeMenu();
  }, [activeMenu]);

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop;
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300;
      }
    }
  }

  return (
    <React.Fragment>
      <SimpleBar style={{ maxHeight: "100%" }} ref={ref}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            <li className="menu-title">{props.t("Main")} </li>
            <li>
              <Link to="/dashboard" className="waves-effect">
                <i className="mdi mdi-view-dashboard"></i>
                <span>{props.t("Dashboard")}</span>
              </Link>
            </li>

            {/* ===== Admin & Data Entry: management menus ===== */}
            {isAdminOrDataEntry && (
              <>
                <li className="menu-title">إدارة البيانات</li>
                <li>
                  <Link to="/#" className="has-arrow waves-effect">
                    <i className="mdi mdi-account-group"></i>
                    <span>الصحفيين</span>
                  </Link>
                  <ul className="sub-menu">
                    <li><Link to="/dashboard/journalists">القائمة</Link></li>
                    <li><Link to="/dashboard/journalists/create">إضافة صحفي</Link></li>
                    <li><Link to="/dashboard/journalists/cards">الكروت</Link></li>
                  </ul>
                </li>
                <li>
                  <Link to="/#" className="has-arrow waves-effect">
                    <i className="mdi mdi-account-heart"></i>
                    <span>الناشطين</span>
                  </Link>
                  <ul className="sub-menu">
                    <li><Link to="/dashboard/activists">القائمة</Link></li>
                    <li><Link to="/dashboard/activists/create">إضافة ناشط</Link></li>
                    <li><Link to="/dashboard/activists/cards">الكروت</Link></li>
                  </ul>
                </li>
                <li>
                  <Link to="/#" className="has-arrow waves-effect">
                    <i className="mdi mdi-office-building"></i>
                    <span>المؤسسات</span>
                  </Link>
                  <ul className="sub-menu">
                    <li><Link to="/dashboard/institutions">القائمة</Link></li>
                    <li><Link to="/dashboard/institutions/create">إضافة مؤسسة</Link></li>
                    <li><Link to="/dashboard/institutions/cards">الكروت</Link></li>
                  </ul>
                </li>
              </>
            )}

            {/* ===== Regular user: view-only menus ===== */}
            {userRole === "user" && (
              <>
                <li className="menu-title">عرض البيانات</li>
                <li>
                  <Link to="/dashboard/journalists/cards" className="waves-effect">
                    <i className="mdi mdi-account-group"></i>
                    <span>كروت الصحفيين</span>
                  </Link>
                </li>
                <li>
                  <Link to="/dashboard/activists/cards" className="waves-effect">
                    <i className="mdi mdi-account-heart"></i>
                    <span>كروت الناشطين</span>
                  </Link>
                </li>
                <li>
                  <Link to="/dashboard/institutions/cards" className="waves-effect">
                    <i className="mdi mdi-office-building"></i>
                    <span>كروت المؤسسات</span>
                  </Link>
                </li>
              </>
            )}

            {/* ===== Approvals: Admin sees pending + logs, data_entry sees my requests ===== */}
            {isAdmin && (
              <>
                <li className="menu-title">الموافقات</li>
                <li>
                  <Link to="/dashboard/pending-approvals" className="waves-effect">
                    <i className="mdi mdi-clipboard-check-outline"></i>
                    <span>طلبات معلّقة</span>
                  </Link>
                </li>
                <li>
                  <Link to="/dashboard/approval-logs" className="waves-effect">
                    <i className="mdi mdi-history"></i>
                    <span>سجل الموافقات</span>
                  </Link>
                </li>
              </>
            )}
            {isDataEntry && (
              <>
                <li className="menu-title">طلباتي</li>
                <li>
                  <Link to="/dashboard/my-requests" className="waves-effect">
                    <i className="mdi mdi-file-document-edit-outline"></i>
                    <span>طلباتي</span>
                  </Link>
                </li>
              </>
            )}

            {/* ===== Admin-only: Users & Settings ===== */}
            {isAdmin && (
              <>
                <li className="menu-title">الإدارة</li>
                <li>
                  <Link to="/dashboard/users" className="waves-effect">
                    <i className="mdi mdi-account-cog"></i>
                    <span>إدارة المستخدمين</span>
                  </Link>
                </li>
                <li>
                  <Link to="/dashboard/settings/whitelist" className="waves-effect">
                    <i className="mdi mdi-shield-account"></i>
                    <span>القائمة البيضاء</span>
                  </Link>
                </li>
              </>
            )}
          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  )
}

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
}

export default withRouter(withTranslation()(SidebarContent))
